// @ts-nocheck
import React from 'react';
import TaskItem from '../../TaskItem';
import { IProjectTaskModel } from '../../../models/ProjectTaskModel';

interface ProjectsCardProps {
  id: number;
  content: IProjectTaskModel;
  style: React.CSSProperties;
  className?: string;
  editTaskRoute?: string;
  canOpenTaskDetail?: boolean;
}

const CARD_STYLE: React.CSSProperties = { width: '250px', marginTop: '5px', marginBottom: '5px' };

export const ProjectsCard = React.memo((props: ProjectsCardProps) => {
  // onClick is intentionally NOT on this div — smooth-dnd swallows DOM click
  // events inside react-trello. Card clicks are handled via the board's
  // onCardClick prop (react-trello's internal event system).
  return (
    <div className={props.className} style={{ ...CARD_STYLE, ...props.style }}>
      <TaskItem
        task={props.content}
        editTaskRoute={props.editTaskRoute}
        canOpenTaskDetail={props.canOpenTaskDetail}
      />
    </div>
  );
});
